import instance from '../middleware/HTTPInterceptors';
import ErrorResponse from '../utilities/ErrorResponse';
import { HTTPResponse } from '../utilities/frontendTypes';
import { getAuthHeader } from '../utilities/helperFunctions';
import * as T from '../utilities/frontendTypes';

export async function getSowRequests(): Promise<T.SowRequestResponse> {
  try {
    const config = {
        headers: await getAuthHeader(),
      }

    const res = await instance.get("/api/providers/get-sow-requests", config);

    return res.data;

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  } 
}

export async function getSowDetails (sowId: string): Promise<T.CreateSowRequestResponse> {
  try {
    const config = {
        headers: await getAuthHeader(),
      }

    const res = await instance.get(`/api/providers/get-sow-details/${sowId}`, config);
    
    if (res.status === 200) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  } 
}

export async function serviceProviderSubmitSow (sowDetails: T.SowDetailToBackend): Promise<T.HTTPResponse> {

  try {
    const config = {
        headers: await getAuthHeader(),
      }

    const res = await instance.put(`/api/providers/submit-sow`, sowDetails, config);
    
    if (res.status === 200) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  } 
}


export async function serviceProviderSaveProgressSow (sowDetails: T.SowDetailToBackend): Promise<T.HTTPResponse> {
  console.log(sowDetails)

  try {
    const config = {
        headers: await getAuthHeader(),
      }

    const res = await instance.put(`/api/providers/save-sow`, sowDetails, config);
    
    if (res.status === 200) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  } 
}

export async function getProviderDashboard(): Promise<{success: boolean, sowArray: {companyName: string, actionItem: string, lastUpdated: Date, tier: string, contactPerson: string, sowId: string, }[], name: string}>  {
  
  try {
    const config = {
      headers: await getAuthHeader(),
    }

    const res = await instance.get(`/api/providers/dashboard`, config);

    if (res.status === 200) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  } 
}

export async function getDownloadUrl(docKey: string): Promise<{success: boolean, url: string }> {
  try {
    const config = {
      headers: await getAuthHeader(),
    }

    const res = await instance.get(`/api/providers/get-pdf/${docKey}`, config);
    
    if (res.status === 200) return res.data;

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  }
}

export async function getInvoicesData(): Promise<{invoiceReadyArray: [{company: string, email: string, tier: string, sowId: string}]}> {
  try {
    const config = {
      headers: await getAuthHeader(),
    }

    const res = await instance.get(`/api/providers/get-invoices-data`, config);
    
    if (res.status === 200) return res.data;

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  }
}

export async function getSowDetailsForInvoice (sowId: string): Promise<{sow: T.Statement, providerPaymentDetails: {transit: number, institution: number, account: number} | null | undefined, coinvest: number}> {
  try {
    const config = {
        headers: await getAuthHeader(),
      }

    const res = await instance.get(`/api/providers/get-create-invoice/${sowId}`, config);
    
    if (res.status === 200) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  } 
}

export async function newRetainerInvoice(sowId: string, total: number): Promise<T.HTTPResponse> {
  try {
    const config = {
      headers: await getAuthHeader(),
    }

    const res = await instance.post(`/api/providers/new-retainer-invoice`, {sowId}, config);

    if (res.status === 200) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: any) {
    throw new ErrorResponse(err.response.data.message, err.response.status);
  } 
}
